import { Component } from "preact";

import models from "models/models";
// import * as languageMap from "shared/languageMap";
// import LanguageSelectorView from "views/LanguageSelectorView";
import * as walkthrough from "walkthrough";

interface Props {
  readAloudEnabled: boolean;
}

interface State {}

export default class ReaderWalkthroughWidget extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
    models.user.on("change:acheivements", this.onAchievementsChanged);
  }

  onAchievementsChanged = () => {
    this.forceUpdate();
  };

  render() {
    // const isRTL =
    //   languageMap.map[models.user.get("currentLearningLanguage")]?.direction ===
    //   "RTL";

    let message;

    if (!walkthrough.hasAchievement("translate")) {
      message = "Click on a word below to translate it";
      // } else if (!walkthrough.hasAchievement("turnPage")) {
      //   message = `Click the ${isRTL ? "◀" : "▶"} arrow to turn the page`;
      // } else if (!walkthrough.hasAchievement("readAloud")) {
      //   message = (
      //     <>
      //       Click the{" "}
      //       <span class="playButton">
      //         <span class="innerIcon">▶</span>
      //       </span>{" "}
      //       play button at the bottom to read aloud
      //     </>
      //   );
    }

    // If the text is in English, show language select dropdown

    if (!message) {
      return null;
    }

    return (
      <div key={message} class="readerWalkthroughWidget">
        {message}
      </div>
    );
  }
}
